import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Fragment } from "react";

/**
 * Metrics row on primary-blue background — mirrors AWS infrastructure stats.
 * section props: kicker, title, stats: [{ value, suffix, label }]
 */
export default function StatsBanner({ section }) {
  if (!section?.stats?.length) return null;
  const { kicker, title, stats } = section;

  return (
    <section className="pmp-stats-banner">
      <Container>
        {(kicker || title) && (
          <div className="text-center mb-4">
            {kicker && (
              <p
                className="pmp-kicker mb-1"
                style={{ color: "rgba(255,255,255,0.5)" }}
              >
                {kicker}
              </p>
            )}
            {title && (
              <h2 className="h3 fw-bold text-white mb-0">{title}</h2>
            )}
          </div>
        )}
        <Row className="justify-content-center align-items-stretch g-0">
          {stats.map((s, i) => (
            <Fragment key={i}>
              {i > 0 && (
                <Col
                  xs="auto"
                  className="d-none d-md-flex pmp-stat-divider mx-1"
                />
              )}
              <Col xs={6} md="auto" className="flex-md-grow-1">
                <div className="pmp-stat-item">
                  <div className="pmp-stat-value">
                    {s.value}
                    {s.suffix && (
                      <span className="pmp-stat-suffix">{s.suffix}</span>
                    )}
                  </div>
                  <div className="pmp-stat-label">{s.label}</div>
                </div>
              </Col>
            </Fragment>
          ))}
        </Row>
      </Container>
    </section>
  );
}
